import firebase from 'firebase/app'
import 'firebase/functions'

const functions = firebase.functions()
export default functions
